import AbstractService from "../../vendors/services/abstractService";
import { fileApi, urlApi } from "../shared/apis/api";
import Environment from "../../environments/environment";

export default class FileService extends AbstractService {
  constructor() {
    super(fileApi, "ManageFile");
  }

  uploadContribuicao(codContribuicao: any, files: any) {
    return this.api.post(
      `${this.rota}/Upload/Contribuicao/${codContribuicao}`,
      this.formataEnvio(files),
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  downloadPropostaNorma(codPropostaNorma: any) {
    return this.api.get(
      `${this.rota}/Download/PropostaNorma/${codPropostaNorma}`
    );
  }

  downloadPropostaNormaZip(ids: any) {
    const _ids = ids.join("&id=");
    return this.api.get(`${this.rota}/Download/PropostaNorma/Zip?id=${_ids}`);
  }

  downloadNormaDefinitiva(codNormaDefinitiva: any) {
    return this.api.get(
      `${this.rota}/Download/NormaDefinitiva/${codNormaDefinitiva}`
    );
  }

  downloadDegravacao(codDegravacao: any) {
    return this.api.get(`${this.rota}/Download/Degravacao/${codDegravacao}`);
  }

  downloadContribuicao(codAnexoContribuicao: any) {
    return this.api.get(
      `${this.rota}/Download/Contribuicao/${codAnexoContribuicao}`
    );
  }

  deleteAnexoContribuicao(codigoAnexoContribuicao: any) {
    return this.api.delete(
      `${this.rota}/DeleteAnexo/Contribuicao?codigoAnexoContribuicao=${codigoAnexoContribuicao}`,
      { skipAuthRedirect: true } as any
    );
  }

  openAnexoPropostaNorma(codPropostaNorma: any) {
    const _baseUrl = this.getFullFileUrl();
    const a = document.createElement("a");
    a.href = `${_baseUrl}/Download/PropostaNorma/FileContent/${codPropostaNorma}`;
    a.download = "";
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    this.getFocus();
  }

  downloadViaIframe(codPropostaNorma: any) {
    const _baseUrl = this.getFullFileUrl();
    const url = `${_baseUrl}/Download/PropostaNorma/FileContent/${codPropostaNorma}`;
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 30000);
  }

  downloadAnexoPropostaNorma(codPropostaNorma: any) {
    return this.api.get(
      `${this.rota}/Download/PropostaNorma/FileContent/${codPropostaNorma}`,
      {
        responseType: "arraybuffer",
      }
    );
  }

  openAnexoDegravacao(codPropostaNorma: any) {
    const _baseUrl = this.getFullFileUrl();
    const a = document.createElement("a");
    a.href = `${_baseUrl}/Download/Degravacao/FileContent/${codPropostaNorma}`;
    a.download = "";
    a.target = "_blank";
    document.body.appendChild(a);
    console.log(a);
    a.click();
    document.body.removeChild(a);
    this.getFocus();
  }

  openAnexoNormaDefinitiva(codPropostaNorma: any) {
    const _baseUrl = this.getFullFileUrl();
    const a = document.createElement("a");
    a.href = `${_baseUrl}/Download/NormaDefinitiva/FileContent/${codPropostaNorma}`;
    a.download = "";
    a.target = "_blank";
    document.body.appendChild(a);
    console.log(a);
    a.click();
    document.body.removeChild(a);
    this.getFocus();
  }

  private formataEnvio(files: any) {
    const formData = this.toFormData({ descricaoArquivo: "teste" });
    for (const file in files) {
      if (file) {
        formData.append("files", files[file]);
      }
      if (files[file].sigiloso) {
        formData.append("sigiloso", files[file].sigiloso);
      }
    }
    return formData;
  }

  getFullFileUrl() {
    if (Environment.getEnv() != "local") {
      return `${Environment.getFileUrl()}/${this.rota}`;
    }
    // return `${this.rota}`;
    return `${Environment.getFileUrl()}/${this.rota}`;

  }
}
